import { render, staticRenderFns } from "./user_auth_detail.vue?vue&type=template&id=64a02484&scoped=true"
import script from "./user_auth_detail.vue?vue&type=script&lang=js"
export * from "./user_auth_detail.vue?vue&type=script&lang=js"
import style0 from "./user_auth_detail.vue?vue&type=style&index=0&id=64a02484&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a02484",
  null
  
)

export default component.exports